export default "__VITE_ASSET__DRSDFQoE__"